var __WEBPACK_NAMESPACE_OBJECT__ = kolibriCoreAppGlobal.lib.vuex;